import { useState } from 'react';

const faqs = [
  {
    q: 'How long will it take to sell my car?',
    a: "Most vehicles sell within 30–45 days. As a rule of thumb, we aim to turn our entire consignment inventory within 60 days. Pricing, condition, and market demand all play a role, and we'll keep you updated throughout the process.",
  },
  {
    q: 'How does Rockhound Auto charge for consignment?',
    a: "We charge a transparent flat fee on all consignments — no hidden costs or surprise deductions. We'll work with you to set the right asking price and communicate every offer that comes in so you stay in control.",
  },
  {
    q: 'Can you help me determine what my car is worth?',
    a: "Absolutely. Our team evaluates all aspects of your vehicle and the current market to determine the best listing price. We combine dealer appraisal tools, auction data, and years of experience to help you reach the right market value.",
  },
  {
    q: 'What if I still have a bank loan on my car?',
    a: 'No problem at all. We handle the entire process from loan payoff to title transfer. Once the car sells, we take care of everything and cut you a check for the difference.',
  },
  {
    q: 'Can buyers trade in their car on my consignment vehicle?',
    a: "Yes! We treat every car on our lot the same, whether we own it or it's on consignment. Accepting trade‑ins gives your vehicle access to the full benefits of being in our inventory and helps it sell faster.",
  },
  {
    q: 'Can a buyer finance my consignment car?',
    a: "Yes. We work with a wide variety of lending institutions that offer financing regardless of the buyer's credit score. This means your consignment vehicle has a much higher chance of selling at a strong price compared to a private sale.",
  },
  {
    q: 'Is my car insured while on your lot?',
    a: "Yes. Your vehicle is covered under our dealer insurance policy while it's in our care. You can rest easy knowing it's protected.",
  },
  {
    q: 'What types of vehicles do you accept for consignment?',
    a: "We accept cars, trucks, SUVs, and vans of all makes and models. Whether it's a $10,000 commuter or a $75,000 truck, we'll give it the same professional treatment and marketing effort.",
  },
];

export default function ConsignmentFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-20 bg-[#F7F5F0]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-['Oswald'] text-4xl md:text-5xl font-bold text-[#1C2B1E] mb-4">
            Consignment FAQ
          </h2>
          <div className="w-24 h-1 bg-[#E8B84B] mx-auto mb-6"></div>
          <p className="text-lg" style={{ color: '#374151' }}>
            Common questions about our consignment services
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => {
            const btnId = `consignment-faq-btn-${index}`;
            const panelId = `consignment-faq-panel-${index}`;
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="bg-white rounded-xl border-2 border-[#E8E2D6] overflow-hidden hover:border-[#E8B84B] transition-all"
              >
                <button
                  id={btnId}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-[#F7F5F0] transition-colors cursor-pointer focus-visible:ring-2 focus-visible:ring-[#1E3A5F] focus-visible:ring-offset-1"
                >
                  <span className="font-semibold text-[#1C2B1E] pr-4">{faq.q}</span>
                  <div
                    aria-hidden="true"
                    className={`w-8 h-8 rounded-full bg-[#E8B84B] flex items-center justify-center flex-shrink-0 transition-transform ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-xl text-[#1C2B1E]"></i>
                  </div>
                </button>
                {isOpen && (
                  <div
                    id={panelId}
                    role="region"
                    aria-labelledby={btnId}
                    className="px-6 pb-5 pt-2"
                  >
                    <p style={{ color: '#374151' }} className="leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}